//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React, { useState } from 'react';
import { NavTab } from 'unison';

interface Props {
  isActive: boolean;
  isNested?: boolean;
  linkAction?: React.ReactNode;
  linkBadge?: React.ReactElement;
  linkIcon?: React.ReactElement;
  onClick?: () => void;
  text: string;
}

export const SidebarPageItemRouteless = ({
  isActive,
  isNested = false,
  linkAction,
  linkBadge,
  linkIcon,
  onClick,
  text,
}: Props) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <NavTab
      className={isNested ? 'cu-nav-nested-item' : ''}
      isActive={isActive}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <>
        <div className='cu-nav-link-wrapper' onClick={onClick}>
          {linkIcon && <div className='cu-nav-link-icon'>{linkIcon}</div>}
          <a className='cu-nav-link'>{text}</a>
          {linkBadge && <div className='cu-nav-link-badge'>{linkBadge}</div>}
        </div>
        {linkAction && <div className='cu-nav-link-action'>{linkAction}</div>}
      </>
    </NavTab>
  );
};

export default SidebarPageItemRouteless;
